import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getTopologicNodes } from '../../../store/fuse/monitoreo';
import { WrapperTopologica } from './styles';
import Nodos from './Nodos';
import Solar from './Solar';

const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTopologicNodes());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <WrapperTopologica>
        <div className="wrapper-transac">
          <section className="flex-col bg-white m-10 rounded-lg mt-0 w-1/3">
            <p className="p-10 font-medium">Nodos</p>
            <Nodos />
          </section>
          <section className="flex-col bg-white m-10 rounded-lg mt-0 w-2/3">
            <Solar />
          </section>
        </div>
      </WrapperTopologica>
    </>
  );
};

export default Index;
